(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProcedureDiagnosis', ProcedureDiagnosis);

    ProcedureDiagnosis.$inject = ['$resource'];

    function ProcedureDiagnosis($resource) {
        var resourceUrl = 'api/procedure-diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByProcedure': {
                url: 'api/procedure-diagnoses/procedure/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
